import React, {FocusEventHandler} from 'react';
import {isNotEmpty} from "@Array/isNotEmpty";
import BestPricesList from "./BestPricesList";
import Translation from "@Translation/components/Translation";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";
import useStsPageDatePickerClickEvent from "@Events/hooks/useStsPageDatePickerClickEvent";

interface BestPriceOnDateRouteListProps {
    bestPriceOnDateData: BestPriceRouteType[],
}

function BestPriceOnDateRouteList ({bestPriceOnDateData}: BestPriceOnDateRouteListProps) {

    const todayButtonClickEvent = useStsPageDatePickerClickEvent("today_button")
    const tomorrowButtonClickEvent = useStsPageDatePickerClickEvent("tomorrow_button")

    const onTodayClick = () => {
        todayButtonClickEvent()
    }

    const onTomorrowButtonClick = () => {
        tomorrowButtonClickEvent()
    }

    return (
        <div className="station-to-station-results">
            {parseInt(window.currencyData.ratio, 10) !== 1 && (
                <a className="station_to_station_ratio hidden">
                    {window.currencyData.currency}
                </a>
            )}
            <div>
                {!window.differentRoutes && (
                    <div className="gb--row gb--row-middle gb--row-end gb--route-filter">
                        <span>
                            <Translation translationKey="menu.main.available_routes"/>
                        </span>
                        <a target="_blank" href={window.todaySearchLink} onClick={onTodayClick} className="js-today-link">
                            <Translation translationKey="url_segments.today" styleText="upperCase"/>
                        </a>
                        <a target="_blank" href={window.tomorrowSearchLink} onClick={onTomorrowButtonClick} className="js-tomorrow-link">
                            <Translation translationKey="url_segments.tomorrow" styleText="upperCase"/>
                        </a>
                    </div>
                )}
            </div>
            <div className="singleRoutes">
                {isNotEmpty(bestPriceOnDateData) ? (
                    <BestPricesList
                        bestPriceOnDateData={bestPriceOnDateData}
                    />
                ) : (
                    <Translation translationKey="no_res.no_results_title"/>
                )}
            </div>
        </div>
        )
}

export default BestPriceOnDateRouteList